import React from 'react';

import CheckIcon from '@material-ui/icons/Check';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    choose: '選択する',
    chosen: '選択済み',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  selectButton: {
    ...common.flexCenter,
    ...common.textPrimary,
    ...common.bigText,
    width: 111,
    height: 38,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.paper,
    '&$selected': {
      border: `1px solid ${theme.palette.common.white}`,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    [theme.breakpoints.down('sm')]: {
      width: 80,
      height: 28,
      ...common.middleText,
    },
  },
  selected: {},
}));

export interface SelectButtonProps extends React.ComponentProps<'button'> {
  selected: boolean;
}

export const SelectButton: React.FC<SelectButtonProps> = (props) => {
  const { selected, className, ...rest } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <button
      className={clsx(classes.selectButton, selected && classes.selected, className)}
      {...rest}
    >
      {!selected && <span>{strings.choose}</span>}
      {selected && (
        <>
          <CheckIcon /> <span>{strings.chosen} </span>
        </>
      )}
    </button>
  );
};
